import { Flex, Text } from "@unifize/sarah";
import type { SubscriptionData } from "src/api/pegasus";
import SubscriptionDetailField from "./SubscriptionDetailField";

type SubscriptionDetailsProps = {
  subscription: SubscriptionData;
  currentStatus: string;
  formatStatusForDisplay: (status: string | null) => string;
};

const SubscriptionDetails = ({
  subscription,
  currentStatus,
  formatStatusForDisplay,
}: SubscriptionDetailsProps) => {
  const isFreeTrial = subscription.subscription["is-free-trial"];

  return (
    <div style={{ position: "relative", marginBottom: "2rem" }}>
      {isFreeTrial && (
        <Flex
          items="center"
          justify="flex-start"
          style={{
            position: "absolute",
            top: "-1.8rem",
            background: "#E0F2FE",
            color: "#075985",
            border: "1px solid #BAE6FD",
            borderTopLeftRadius: "10px",
            borderTopRightRadius: "10px",
            padding: "0.25rem 0.75rem",
          }}
        >
          <Text variant="caption" weight="medium">
            Free Trial
          </Text>
        </Flex>
      )}

      <Flex
        direction="column"
        style={{
          border: "1px solid #D1D5DB",
          borderRadius: "0.5rem",
          marginBottom: 0,
        }}
      >
        <Flex
          justify="space-between"
          items="flex-start"
          wrap="wrap"
          gap="4"
          style={{
            marginBottom: "2rem",
            padding: "1rem 1.5rem",
            borderBottom: "1px solid #D1D5DB",
          }}
        >
          <Flex direction="column">
            <Text variant="regular" color="#101828">
              Subscription Details
            </Text>
            <Text weight="regular" color="#667085">
              Review your Azure Marketplace subscription information.
            </Text>
          </Flex>
          <Flex
            background="#E5E7EB"
            direction="column"
            items="flex-start"
            gap="0.25rem"
            wrap="nowrap"
            style={{
              padding: "0.125rem 0.5rem",
              borderRadius: "9999px",
            }}
          >
            <Text variant="caption" weight="regular" color="#000">
              {formatStatusForDisplay(currentStatus)}
            </Text>
          </Flex>
        </Flex>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
            gap: "2rem",
            marginBottom: "2rem",
            padding: "1.5rem",
          }}
        >
          <Flex direction="column" gap="6">
            <SubscriptionDetailField
              label="Subscription Name"
              value={subscription["subscription-name"]}
            />
            <SubscriptionDetailField
              label="Plan Name"
              value={subscription.subscription.name}
            />
            <SubscriptionDetailField
              label="Purchaser Email"
              value={subscription.subscription.purchaser["email-id"]}
            />
            <SubscriptionDetailField
              label="Quantity"
              value={subscription.subscription.quantity ?? "N/A"}
            />
            <SubscriptionDetailField
              label="Publisher ID"
              value={subscription.subscription["publisher-id"]}
            />
          </Flex>

          <Flex direction="column" gap="6">
            <SubscriptionDetailField
              label="Subscription ID"
              value={subscription.subscription.id}
            />
            <SubscriptionDetailField
              label="Plan ID"
              value={subscription.subscription["plan-id"]}
            />
            <SubscriptionDetailField
              label="Tenant ID"
              value={subscription.subscription.purchaser["tenant-id"]}
            />
            <SubscriptionDetailField
              label="Offer ID"
              value={subscription.subscription["offer-id"]}
            />
          </Flex>
        </div>
      </Flex>
    </div>
  );
};

export default SubscriptionDetails;
